export default function() {
  return Math.random();
}



//////////////////
// WEBPACK FOOTER
// D:/glois.angular/~/d3-random/src/defaultSource.js
// module id = ../../../../d3-random/src/defaultSource.js
// module chunks = 4